jQuery(document).ready(function ($) {
    var page = 2;
    var loading = false;
    var currentCategory = 0;
    var $loadMoreBtn = $('#load-more-posts');
    var $archiveGrid = $('#archiveGrid');
    var $catLinks = $('.archive-cat-link[data-category]');

    if (!$archiveGrid.length) return;

    // Load More
    if ($loadMoreBtn.length) {
        $loadMoreBtn.on('click', function () {
            if (loading) return;

            loading = true;
            $loadMoreBtn.html('<i class="fa-light fa-spinner fa-spin"></i> Načítám...');

            $.ajax({
                url: MyAjax.ajaxurl,
                type: 'POST',
                data: {
                    action: 'load_more_posts',
                    page: page,
                    category: currentCategory
                },
                success: function (response) {
                    if (response.html) {
                        $archiveGrid.append(response.html);
                        page++;
                    }

                    if (!response.has_more_posts) {
                        $loadMoreBtn.fadeOut(300);
                    }

                    loading = false;
                    $loadMoreBtn.html('Načíst další <i class="fa-light fa-arrow-down"></i>');
                },
                error: function () {
                    loading = false;
                    $loadMoreBtn.html('Načíst další <i class="fa-light fa-arrow-down"></i>');
                }
            });
        });
    }

    // Category Filter (AJAX - for modular page version)
    if ($catLinks.length) {
        $catLinks.on('click', function () {
            if (loading) return;

            var $this = $(this);
            var category = $this.data('category');

            $catLinks.removeClass('active');
            $this.addClass('active');

            currentCategory = category;
            page = 2;
            loading = true;

            $archiveGrid.css('opacity', '0.5');

            $.ajax({
                url: MyAjax.ajaxurl,
                type: 'POST',
                data: {
                    action: 'filter_posts',
                    category: category
                },
                success: function (response) {
                    $archiveGrid.html(response.html || '<div class="archive-empty"><i class="fa-light fa-newspaper"></i><p>V této kategorii zatím nemáme žádné články.</p></div>');
                    $archiveGrid.css('opacity', '1');

                    if (response.has_more_posts) {
                        $loadMoreBtn.show();
                    } else {
                        $loadMoreBtn.hide();
                    }

                    loading = false;
                },
                error: function () {
                    $archiveGrid.css('opacity', '1');
                    loading = false;
                }
            });
        });
    }
});
